import Metrics from '../Metrics'
import { BoxSizes, Chart, Dashboard } from './types'

const JLP: Dashboard = {
  id: 'JLP',
  name: 'JLP',
  daterange: true,
  metrics: [
    {
      type: Metrics.JLP_DWELL_TIME_SKU,
      'box-size': BoxSizes.MID,
      chart: Chart.List,
      title: 'dashboard-dwelltime',
      count: 'dashboard-count-products',
      'count-data': 'dashboard-count-time',
    },
    {
      type: Metrics.JLP_BUTTONS,
      'box-size': BoxSizes.BIG,
      chart: Chart.Bars,
      title: 'dashboard-buttons',
      count: 'dashboard-count-touches',
    },
    {
      type: Metrics.JLP_SESSIONS_SKU,
      'box-size': BoxSizes.MID,
      chart: Chart.List,
      title: 'dashboard-sessions',
      count: 'dashboard-count-products',
      'count-data': 'dashboard-count-sessions',
    },
  ],
}

export default JLP
